import { AnimatePresence } from "framer-motion";
import { memo, useEffect, useMemo, useRef } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import LoadingComponent from "./components/LoadingComponent/LoadingComponent.tsx";
import { useProfile } from "./contexts/ProfileContext.tsx";
import { Filial as FilialModel } from "./models/Filial.ts";
import Avisos from "./pages/Avisos/Avisos";
import GrupoPrecificacao from "./pages/GrupoPrecificacao/GrupoPrecificacao";
import CrudCheckAdiciona from "./pages/ModuloChecklist/AdicionaCheckFrota/CrudCheckAdiciona/CrudCheckAdiciona";
import FrotaAdiciona from "./pages/ModuloChecklist/AdicionaCheckFrota/FrotaAdiciona";
import Checkagem from "./pages/ModuloChecklist/Checkagem/Checkagem";
import CrudCheck from "./pages/ModuloChecklist/Frota/CrudCheck/CrudCheck";
import Frota from "./pages/ModuloChecklist/Frota/Frota";
import TipoCheckagem from "./pages/ModuloChecklist/TipoCheckagem/TipoCheckagem";
import CrudCheckVencido from "./pages/ModuloChecklist/VeiculosVencidos/CrudCheckVencido/CrudCheckVencido";
import VeiculosVencidos from "./pages/ModuloChecklist/VeiculosVencidos/VeiculosVencidos";
import AguardaCTE from "./pages/ModuloGerenciador/AguardaCTE/AguardaCTE";
import Ajuda from "./pages/ModuloGerenciador/Ajuda/Ajuda";
import Alertas from "./pages/ModuloGerenciador/Alertas/Alertas";
import CadastrarUsuario from "./pages/ModuloGerenciador/CadastrarUsuario/CadastrarUsuario";
import CadastroUsuario from "./pages/ModuloGerenciador/CadastrarUsuario/CadastroUsuario/CadastroUsuario";
import SalvaSenha from "./pages/ModuloGerenciador/CadastrarUsuario/SalvaSenha/SalvaSenha";
import Cliente from "./pages/ModuloGerenciador/Cliente/Cliente";
import Cockpit from "./pages/ModuloGerenciador/Cockpit/Cockpit";
import ConfiguracaoEmpresa from "./pages/ModuloGerenciador/ConfiguracaoEmpresa/ConfiguracaoEmpresa";
import ConfiguracoesColunas from "./pages/ModuloGerenciador/Configuracoes/ConfiguracoesColunas/ConfiguracoesColunas";
import ConfiguracoesCores from "./pages/ModuloGerenciador/Configuracoes/ConfiguracoesCores/ConfiguracoesCores";
import EnviarEmail from "./pages/ModuloGerenciador/Configuracoes/EnviarEmail/EnviarEmail";
import Filiais from "./pages/ModuloGerenciador/Configuracoes/Filiais/Filiais";
import Notificacoes from "./pages/ModuloGerenciador/Configuracoes/Notificacoes/Notificacoes";
import Cotacao from "./pages/ModuloGerenciador/Cotacao/Cotacao";
import ClassificacaoPontos from "./pages/ModuloGerenciador/Dashboards/ClassificacaoPontos/ClassificacaoPontos.tsx";
import CockpitDashboard from "./pages/ModuloGerenciador/Dashboards/CockpitDashboard/CockpitDashboard";
import Dashboard from "./pages/ModuloGerenciador/Dashboards/Dashboard/Dashboard";
import DashboardCotacao from "./pages/ModuloGerenciador/Dashboards/DashboardCotacao/DashboardCotacao";
import DashboardOcorrencias from "./pages/ModuloGerenciador/Dashboards/DashboardOcorrencias/DashboardOcorrencias";
import DashboardResponsaveis from "./pages/ModuloGerenciador/Dashboards/DashboardResponsaveis/DashboardResponsaveis";
import ElegibilidadeBrf from "./pages/ModuloGerenciador/Dashboards/ElegibilidadeBrf/ElegibilidadeBrf.tsx";
import IndicadorFaturamentoMensal from "./pages/ModuloGerenciador/Dashboards/IndicadorFaturamentoMensal/IndicadorFaturamentoMensal.tsx";
import QuartoDashboard from "./pages/ModuloGerenciador/Dashboards/QuartoDashboard/QuartoDashboard.js";
import QuintoDashboard from "./pages/ModuloGerenciador/Dashboards/QuintoDashboard/QuintoDashboard.js";
import RelatorioProprietarios from "./pages/ModuloGerenciador/Dashboards/RelatorioProprietarios/RelatorioProprietarios";
import SegundoDashboard from "./pages/ModuloGerenciador/Dashboards/SegundoDashboard/SegundoDashboard.js";
import SetimoDashboard from "./pages/ModuloGerenciador/Dashboards/SetimoDashboard/SetimoDashboard.js";
import SextoDashboard from "./pages/ModuloGerenciador/Dashboards/SextoDashboard/SextoDashboard.js";
import TerceiroDashboard from "./pages/ModuloGerenciador/Dashboards/TerceiroDashboard/TerceiroDashboard.js";
import Diaria from "./pages/ModuloGerenciador/Diaria/Diaria";
import Diarias from "./pages/ModuloGerenciador/Diarias/Diarias";
import DisponibilidadeFrota from "./pages/ModuloGerenciador/DisponibilidadeFrota/DisponibilidadeFrota.tsx";
import DivergenciasSAT from "./pages/ModuloGerenciador/DivergenciasSAT/DivergenciasSAT.tsx";
import Documentacao from "./pages/ModuloGerenciador/Documentacao/Documentacao";
import AutoEditar from "./pages/ModuloGerenciador/EditarUsuario/AutoEditar/AutoEditar.tsx";
import EditarUsuario from "./pages/ModuloGerenciador/EditarUsuario/EditarUsuario";
import CadastrarEmbarque from "./pages/ModuloGerenciador/Embarque/CadastrarEmbarque.tsx";
import { EditarEmbarque } from "./pages/ModuloGerenciador/Embarque/EditarEmbarque.tsx";
import Embarque from "./pages/ModuloGerenciador/Embarque/Embarque";
import EmbarqueMesoRegiao from "./pages/ModuloGerenciador/Embarque/MesoRegiao/EmbarqueMesoRegiao";
import MapaMeso from "./pages/ModuloGerenciador/Embarque/MesoRegiao/Mapa/MapaMeso.js";
import AlteraSenha from "./pages/ModuloGerenciador/EsqueciSenha/AlteraSenha/AlteraSenha";
import CodigoEmail from "./pages/ModuloGerenciador/EsqueciSenha/CodigoEmail/CodigoEmail";
import RecuperarSenha from "./pages/ModuloGerenciador/EsqueciSenha/RecuperaSenha/RecuperarSenha";
import Estadia from "./pages/ModuloGerenciador/Estadia/Estadia";
import Faturamento from "./pages/ModuloGerenciador/Faturamento/Faturamento";
import Feedback from "./pages/ModuloGerenciador/Feedback/Feedback";
import FinalizarViagem from "./pages/ModuloGerenciador/FinalizarViagem/FinalizarViagem.tsx";
import GerenciamentoPedido from "./pages/ModuloGerenciador/GerenciamentoPedido/GerenciamentoPedido";
import GrupoCarga from "./pages/ModuloGerenciador/GrupoCarga/GrupoCarga";
import GrupoCargaVinculo from "./pages/ModuloGerenciador/GrupoCargaVinculo/GrupoCargaVinculo";
import GrupoClientes from "./pages/ModuloGerenciador/GrupoClientes/GrupoClientes";
import GrupoComClientes from "./pages/ModuloGerenciador/GrupoComClientes/GrupoComClientes";
import Home from "./pages/ModuloGerenciador/Home/Home.tsx";
import Login from "./pages/ModuloGerenciador/Login/Login.tsx";
import CadastrarModeloViagens from "./pages/ModuloGerenciador/ModeloViagens/CadastrarModeloViagens.tsx";
import EditarModeloViagens from "./pages/ModuloGerenciador/ModeloViagens/EditarModeloViagens.tsx";
import ModeloViagens from "./pages/ModuloGerenciador/ModeloViagens/ModeloViagens.tsx";
import MotivoOnTime from "./pages/ModuloGerenciador/MotivoOnTime/MotivoOnTime";
import Motorista from "./pages/ModuloGerenciador/Motorista/Motorista";
import OnTime from "./pages/ModuloGerenciador/OnTime/OnTime";
import OnTimeEmbarque from "./pages/ModuloGerenciador/OnTimeEmbarque/OnTimeEmbarque";
import OnTimeEntrega from "./pages/ModuloGerenciador/OnTimeEntrega/OnTimeEntrega";
import Painel from "./pages/ModuloGerenciador/Painel/Painel";
import Pedido from "./pages/ModuloGerenciador/Pedido/Pedido";
import PoliticaPrivacidade from "./pages/ModuloGerenciador/Politicas/PoliticaPrivacidade";
import CadastroPrestacaoDeServico from "./pages/ModuloGerenciador/PrestacaoDeServico/CadastroPrestacaoDeServico.tsx";
import PrestacaoDeServico from "./pages/ModuloGerenciador/PrestacaoDeServico/PrestacaoDeServico.tsx";
import Rota from "./pages/ModuloGerenciador/Rota/Rota";
import SolicitacaoAgregados from "./pages/ModuloGerenciador/SolicitacaoAgregados/SolicitacaoAgregados.js";
import Solicitacoes from "./pages/ModuloGerenciador/Solicitacoes/Solicitacoes";
import Sorteio from "./pages/ModuloGerenciador/Sorteio/Sorteio";
import CidadeEstado from "./pages/ModuloGerenciador/UsoComum/CidadeEstado/CidadeEstado";
import Embalagem from "./pages/ModuloGerenciador/UsoComum/Embalagem/Embalagem";
import EmpresaSubsidiaria from "./pages/ModuloGerenciador/UsoComum/EmpresaSubsidiaria/EmpresaSubsidiaria";
import Filial from "./pages/ModuloGerenciador/UsoComum/Filial/Filial";
import MeioPagamento from "./pages/ModuloGerenciador/UsoComum/MeioPagamento/MeioPagamento";
import Mercadoria from "./pages/ModuloGerenciador/UsoComum/Mercadoria/Mercadoria";
import Motivo from "./pages/ModuloGerenciador/UsoComum/Motivo/Motivo";
import MotivoCotacao from "./pages/ModuloGerenciador/UsoComum/MotivoCotacao/MotivoCotacao";
import MotivoEstadia from "./pages/ModuloGerenciador/UsoComum/MotivoEstadia/MotivoEstadia";
import Ocorrencia from "./pages/ModuloGerenciador/UsoComum/Ocorrencia/Ocorrencia";
import Proprietario from "./pages/ModuloGerenciador/UsoComum/Proprietario/Proprietario";
import SegmentoCliente from "./pages/ModuloGerenciador/UsoComum/SegmentoCliente/SegmentoCliente";
import Status from "./pages/ModuloGerenciador/UsoComum/Status/Status";
import StatusDiaria from "./pages/ModuloGerenciador/UsoComum/StatusDiaria/StatusDiaria";
import SubTipoOcorrencia from "./pages/ModuloGerenciador/UsoComum/SubTipoOcorrencia/SubTipoOcorrencia";
import TaxaIcms from "./pages/ModuloGerenciador/UsoComum/TaxaIcms/TaxaIcms";
import TipoCarroceria from "./pages/ModuloGerenciador/UsoComum/TipoCarroceria/TipoCarroceria";
import TipoContato from "./pages/ModuloGerenciador/UsoComum/TipoContato/TipoContato";
import TipoDocumento from "./pages/ModuloGerenciador/UsoComum/TipoDocumento/TipoDocumento";
import TipoOcorrencia from "./pages/ModuloGerenciador/UsoComum/TipoOcorrencia/TipoOcorrencia";
import TipoVeiculo from "./pages/ModuloGerenciador/UsoComum/TipoVeiculo/TipoVeiculo";
import Caminhao from "./pages/ModuloGerenciador/Veiculo/Caminhao/Caminhao";
import Carreta from "./pages/ModuloGerenciador/Veiculo/Carreta/Carreta";
import DiariaVeiculo from "./pages/ModuloGerenciador/Veiculo/DiariaVeiculo/DiariaVeiculo";
import Veiculo from "./pages/ModuloGerenciador/Veiculo/Veiculo/Veiculo";
import ViagensDeletadas from "./pages/ModuloGerenciador/ViagensDeletadas/ViagensDeletadas.tsx";
import ViagensFinalizadasMotorista from "./pages/ModuloGerenciador/ViagensFinalizadasMotorista/ViagensFinalizadasMotorista.tsx";
import LocalizadorVeiculos from "./pages/ModuloRastreamento/LocalizadorVeiculos/LocalizadorVeiculos";
import Rastreamento from "./pages/ModuloRastreamento/Rastreamento/Rastreamento";
import Rastrear from "./pages/ModuloRastreamento/Rastrear/Rastrear";
import TipoRastreamento from "./pages/ModuloRastreamento/TipoRastreamento/TipoRastreamento";
import ValorEmbarque from "./pages/ValorEmbarque/ValorEmbarque";

const RedirectToViagens = memo(() => {
    const { handleSetContextoEmbarque } = useProfile();
    const navigate = useNavigate();
    handleSetContextoEmbarque("todos");
    navigate("/viagens/todos");
    return null;
});

const PublicRoutes = memo(() => {
    const location = useLocation();

    return (
        <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
                <Route key={location.pathname} path="/" element={<Login />} />
                <Route key={location.pathname} path="*" element={<Login />} />
                <Route key={location.pathname} path="/login" element={<Login />} />
                <Route
                    key={location.pathname}
                    path="/emailSenha"
                    element={<CodigoEmail />}
                />
                <Route
                    key={location.pathname}
                    path="/recuperarSenha"
                    element={<RecuperarSenha />}
                />
                <Route
                    key={location.pathname}
                    path="/cadastroUsuario"
                    element={<CadastroUsuario />}
                />
                <Route
                    key={location.pathname}
                    path="/salvarSenha"
                    element={<SalvaSenha />}
                />
                <Route
                    key={location.pathname}
                    path="/politica-privacidade"
                    element={<PoliticaPrivacidade />}
                />
                <Route
                    key={location.pathname}
                    path="/viagem/finalizar-viagem/:id"
                    element={<FinalizarViagem />}
                />
            </Routes>
        </AnimatePresence>
    );
});

const PrivateRoutes = memo(() => {
    const { dadosFilial, profile, contextoEmbarque } = useProfile();
    const location = useLocation();
    const { pathname } = location;
    const navigate = useNavigate();

    const contextosPermitidoCadastro = useMemo(() => {
        return (
            dadosFilial
                ?.filter((filial: FilialModel) => filial.contexto !== "todos")
                .map((filial: FilialModel) => filial.contexto) || []
        );
    }, [dadosFilial]);

    const isRotaCadastroViagens = useMemo(
        () => pathname.includes("/viagens/") && pathname.includes("/cadastro"),
        [pathname]
    );

    const rotaHasId = useMemo(() => {
        return (
            pathname.includes("/viagens/") &&
            pathname.includes("/cadastro/") &&
            !pathname.endsWith("/cadastro")
        );
    }, [pathname]);

    const rotaId = useMemo(() => {
        const parts = pathname.split("/");
        return parts[4] || null;
    }, [pathname]);

    useEffect(() => {
        if (
            isRotaCadastroViagens &&
            !!contextosPermitidoCadastro.length &&
            !contextosPermitidoCadastro.includes(pathname.split("/")[2]) &&
            contextoEmbarque
        ) {
            navigate(
                `/viagens/${contextoEmbarque}/cadastro${rotaHasId ? `/${rotaId}` : ""}`
            );
        }
    }, [isRotaCadastroViagens, contextosPermitidoCadastro, pathname, contextoEmbarque, navigate, rotaHasId, rotaId]);

    if (
        !profile?.token ||
        !contextosPermitidoCadastro?.length
    ) {
        return <LoadingComponent />;
    }

    return (
        <Routes location={location} key={pathname}>
            <Route
                key={location.pathname} path="" element={<Home />} />
            <Route
                key={location.pathname} path="/" element={<Home />} />
            <Route
                key={location.pathname} path="*" element={<Home />} />
            <Route
                key={location.pathname} path="/cadastrar-usuario"
                element={<CadastrarUsuario />}
            />
            <Route path="/solicitacoes" element={<Solicitacoes />} />
            <Route path="/cadastroUsuario" element={<CadastroUsuario />} />
            <Route path="/salvarSenha" element={<SalvaSenha />} />
            <Route path="/alterarSenha" element={<AlteraSenha />} />
            <Route path="/emailSenha" element={<CodigoEmail />} />
            <Route path="/recuperarSenha" element={<RecuperarSenha />} />
            <Route path="/envia-email" element={<EnviarEmail />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/notificacoes" element={<Notificacoes />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/segundo-dashboard" element={<SegundoDashboard />} />
            <Route path="/terceiro-dashboard" element={<TerceiroDashboard />} />
            <Route path="/quarto-dashboard" element={<QuartoDashboard />} />
            <Route path="/quinto-dashboard" element={<QuintoDashboard />} />
            <Route path="/sexto-dashboard" element={<SextoDashboard />} />
            <Route path="/setimo-dashboard" element={<SetimoDashboard />} />
            <Route path="/dashboard-cockpit" element={<CockpitDashboard />} />
            <Route path="/indicador-faturamento-mensal" element={<IndicadorFaturamentoMensal />} />
            <Route
                key="editar-usuario"
                path="/editar-usuario"
                element={<EditarUsuario />}
            />
            <Route path="/dados-usuario" element={<AutoEditar />} />
            <Route path="/cliente" element={<Cliente />} />
            <Route path="/cockpit" element={<Cockpit />} />
            <Route path="/grupo-clientes" element={<GrupoClientes />} />
            <Route path="/vincular-clientes" element={<GrupoComClientes />} />
            <Route path="/solicitacoes-agregados" element={<SolicitacaoAgregados />} />
            <Route path="/modelo-viagens" element={<ModeloViagens />} />
            <Route
                path="/modelo-viagens/cadastro"
                element={<CadastrarModeloViagens />}
            />
            <Route
                path="/modelo-viagens/editar/:id"
                element={<EditarModeloViagens />}
            />
            <Route
                key={location.pathname} path="/embarque" element={<RedirectToViagens />} />
            <Route path="/viagens/:contexto" element={<Embarque />} />
            <Route
                key={location.pathname}
                path="/viagens/:contexto/cadastro"
                element={<CadastrarEmbarque />}
            />
            <Route
                path="/viagens/:contexto/cadastro/:id/:origem?"
                element={<EditarEmbarque />}
            />
            <Route
                key={location.pathname}
                path="/viagens-deletadas"
                element={<ViagensDeletadas />}
            />
            <Route
                key={location.pathname}
                path="/viagens-finalizadas-motorista"
                element={<ViagensFinalizadasMotorista />}
            />
            <Route path="/diaria-veiculos" element={<DiariaVeiculo />} />
            <Route path="/documentacao" element={<Documentacao />} />
            <Route path="/motorista" element={<Motorista />} />
            <Route path="/pedido" element={<Pedido />} />
            <Route path="/rota" element={<Rota />} />
            <Route path="/cidade-estado" element={<CidadeEstado />} />
            <Route path="/embalagem" element={<Embalagem />} />
            <Route path="/filiais" element={<Filiais />} />
            <Route path="/empresa-sub" element={<EmpresaSubsidiaria />} />
            <Route path="/filial" element={<Filial />} />
            <Route path="/meio-pagamento" element={<MeioPagamento />} />
            <Route path="/status" element={<Status />} />
            <Route path="/motivo" element={<Motivo />} />
            <Route path="/configuracoes-cores" element={<ConfiguracoesCores />} />
            <Route path="/configuracoes-coluna" element={<ConfiguracoesColunas />} />
            <Route path="/taxa-icms" element={<TaxaIcms />} />
            <Route path="/proprietario" element={<Proprietario />} />
            <Route path="/mercadoria" element={<Mercadoria />} />
            <Route path="/caminhoes" element={<Caminhao />} />
            <Route path="/carretas" element={<Carreta />} />
            <Route path="/conjuntos" element={<Veiculo />} />
            <Route path="/faturamento" element={<Faturamento />} />
            <Route path="/avisos" element={<Avisos />} />
            <Route path="/checkagem" element={<Checkagem />} />
            <Route path="/frota" element={<Frota />} />
            <Route path="/adicionar-check-veiculo" element={<FrotaAdiciona />} />
            <Route path="/tipo-checkagem" element={<TipoCheckagem />} />
            <Route path="/cadastro-check" element={<CrudCheck />} />
            <Route path="/cadastro-check-adiciona" element={<CrudCheckAdiciona />} />
            <Route path="/ajuda" element={<Ajuda />} />
            <Route path="/veiculos-vencidos" element={<VeiculosVencidos />} />
            <Route path="/cadastro-check-vencidos" element={<CrudCheckVencido />} />
            <Route path="/tipo-rastreamento" element={<TipoRastreamento />} />
            <Route path="/rastreamento" element={<Rastreamento />} />
            <Route path="/rastrear" element={<Rastrear />} />
            <Route path="/localizador-veiculos" element={<LocalizadorVeiculos />} />
            <Route path="/disponibilidade-frota" element={<DisponibilidadeFrota />} />
            <Route path="/precificacao" element={<ValorEmbarque />} />
            <Route path="/motivo-ontime" element={<MotivoOnTime />} />
            <Route path="/ontime" element={<OnTime />} />
            <Route path="/ontime-embarque" element={<OnTimeEmbarque />} />
            <Route path="/ontime-entrega" element={<OnTimeEntrega />} />
            <Route path="/grupo-precificacao" element={<GrupoPrecificacao />} />
            <Route path="/painel" element={<Painel />} />
            <Route path="/grupo-cargas" element={<GrupoCarga />} />
            <Route path="/grupo-cargas-vinculo" element={<GrupoCargaVinculo />} />
            <Route path="/responsaveis" element={<DashboardResponsaveis />} />
            <Route path="/dashboard-cotacao" element={<DashboardCotacao />} />
            <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
            <Route path="/cotacao" element={<Cotacao />} />
            <Route path="/tipo-veiculo" element={<TipoVeiculo />} />
            <Route path="/tipo-carroceria" element={<TipoCarroceria />} />
            <Route path="/alertas" element={<Alertas />} />
            <Route path="/motivo-cotacao" element={<MotivoCotacao />} />
            <Route path="/segmento-cliente" element={<SegmentoCliente />} />
            <Route path="/gerenciamento-pedido" element={<GerenciamentoPedido />} />
            <Route path="/ocorrencia" element={<Ocorrencia />} />
            <Route path="/tipo-ocorrencia" element={<TipoOcorrencia />} />
            <Route path="/sub-tipo-ocorrencia" element={<SubTipoOcorrencia />} />
            <Route path="/dashboard-ocorrencias" element={<DashboardOcorrencias />} />
            <Route
                path="/relatorio-proprietarios"
                element={<RelatorioProprietarios />}
            />
            <Route path="/aguardando-cte" element={<AguardaCTE />} />
            <Route path="/sorteio" element={<Sorteio />} />
            <Route path="/configuracao-empresa" element={<ConfiguracaoEmpresa />} />
            <Route path="/diaria" element={<Diaria />} />
            <Route path="/diarias" element={<Diarias />} />
            <Route path="/tipo-documento" element={<TipoDocumento />} />
            <Route path="/tipo-contato" element={<TipoContato />} />
            <Route path="/diaria-status" element={<StatusDiaria />} />
            <Route path="/motivo-estadia" element={<MotivoEstadia />} />
            <Route path="/estadia" element={<Estadia />} />
            <Route path="/mesorregiao" element={<EmbarqueMesoRegiao />} />
            <Route path="/mapa-meso" element={<MapaMeso />} />
            <Route path="/elegebilidade-brf" element={<ElegibilidadeBrf />} />
            <Route
                key="classificacao-pontos"
                path="/classificacao-pontos"
                element={<ClassificacaoPontos />}
            />
            <Route key={location.pathname} path="/prestacao-servico" element={<PrestacaoDeServico />} />
            <Route key={location.pathname} path="/prestacao-servico/cadastro" element={<CadastroPrestacaoDeServico />} />
            <Route key={location.pathname} path="/divergencias-sat" element={<DivergenciasSAT />} />
        </Routes>
    );
});

const AnimatedRoutes = () => {
    const { profile, handleLoadData } = useProfile();
    const hasCalledLoadData = useRef(false);

    useEffect(() => {
        if (!profile?.usuario?.idUsuario && localStorage.getItem("token") && !hasCalledLoadData.current) {
            handleLoadData();
            hasCalledLoadData.current = true;
        }
    }, [profile?.usuario?.idUsuario, handleLoadData]);

    if (!profile?.usuario?.idUsuario && !localStorage.getItem("token")) {
        return (
            <AnimatePresence>
                <PublicRoutes />;
            </AnimatePresence>
        );
    }

    return (
        <AnimatePresence mode="wait">
            <PrivateRoutes />
        </AnimatePresence>
    );
};

export default AnimatedRoutes;
